// FloatingWhatsAppButton.js
import React, { useEffect, useState } from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import { useLocation } from 'react-router-dom';

export default function FloatingWhatsAppButton() {
  const phoneNumber = '+2349038000420'; // Replace with your business phone number
  const message = encodeURIComponent('Hello! I\'d like to inquire about your menu.');
  const location = useLocation();
  const [shouldShow, setShouldShow] = useState(true);
  
  useEffect(() => {
    // Hide button if the current path is "/farm"
    setShouldShow(location.pathname !== '/farm');
  }, [location]);
  
  const handleClick = () => {
    window.open(`https://wa.me/${phoneNumber}?text=${message}`, '_blank');
  };
  
  // Don't render anything if we're on the /farm route
  if (!shouldShow) return null;
  
  return (
    <button
      onClick={handleClick}
      className="fixed bottom-4 right-4 bg-green-500 text-white p-4 rounded-full shadow-lg hover:bg-green-600 transition duration-300 z-50"
      aria-label="Chat with us on WhatsApp"
    >
      <FaWhatsapp size={24} />
    </button>
  );
}